import React, { useEffect, useState } from "react";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { statesName } from "../../../../TCPForms/data";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";

const SubStep2 = ({ formData, handleSubTabChange, isEmployee }) => {
  const { t } = useTranslation();
  const { documents } = useSelector((state) => state.formMT);
  const defaultValues = {
    ...formData,
    landInfo: {
      ...formData?.landInfo,
    },
  };
  const userInfo = Digit.UserService.getUser()?.info || {};
  const tenantId = Digit.ULBService.getStateId();
  const { handleSubmit, control, setValue, watch, reset } = useForm({ defaultValues });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes(tenantId));
  const watchState = watch("landInfo.owners.[0].permanentAddress.state");
  const [engineersArr, setEngsArr] = useState([]);
  const [user, setUser] = useState(null);
  const [selcectedEng, setSelectedEng] = useState(null);
  const watchStructuralName = watch("structuralInfo.name");
  const getUserInfo = async () => {
    const uuid = userInfo?.uuid;
    if (uuid) {
      const usersResponse = await Digit.UserService.userSearch(tenantId, { uuid: [uuid] }, {});
      setUser(usersResponse?.user?.[0]);
    }
  };
  const [watchCategoryType, watchCertNo, watchValidity] = watch([
    "professionaldetails.consultantCategory",
    "professionaldetails.certificateNo",
    "professionaldetails.validupto",
  ]);
  useEffect(async () => {
    const uuid = userInfo?.uuid;
    if (uuid) {
      const userResponse = await Digit.UserService.userSearch(tenantId, { uuid: [uuid] }, {});
      const fetchedUser = userResponse?.user?.[0];
      setUser(fetchedUser);
      if (fetchedUser) {
        const category = fetchedUser?.roles?.filter((e) => e.code !== "CITIZEN")?.[0]?.name;
        setValue("professionaldetails.consultantCategory", category);
        setValue("professionaldetails.certificateNo", fetchedUser?.registrationNumber);

        const validUptoDate = fetchedUser?.pwdExpiryDate?.slice(0, 10);
        const formattedDate = validUptoDate ? validUptoDate.split("-").reverse().join("-") : null;
        setValue("professionaldetails.validupto", formattedDate);
      }
    }
  }, []);
  useEffect(async () => {
    const structualEngResponse = await Digit.UserService.userSearch(tenantId, { roleCodes: ["BPA_STRUCTURALENGINEER"], pageSize: "100000" });
    const users = structualEngResponse?.user.filter((user) => !["test", null].includes(user.registrationNumber));
    setEngsArr(users);
    const selectedEngineer = users.filter((user) => user.uuid === formData.professionaldetails.engineerUuid)?.[0];
    if (selectedEngineer) {
      setSelectedEng(selectedEngineer);
    }
  }, []);
  useEffect(() => {
    const selectEng = engineersArr.filter((e) => e.name === watchStructuralName);
    if (selectEng.length > 0) {
      const selectedEngineer = selectEng[0];
      setValue("structuralInfo.licenseNumber", selectedEngineer?.registrationNumber);
      const validUptoDate = selectedEngineer?.pwdExpiryDate?.slice(0, 10);
      const formattedDate = validUptoDate
        ? validUptoDate.split("-").reverse().join("-") // Rearrange to 'DD-MM-YYYY'
        : null;
      setValue("structuralInfo.validupto", formattedDate);
      setValue("structuralInfo.permanentAddress.address", selectedEngineer?.permanentAddress?.address);
    }
  }, [watchStructuralName]);

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  useEffect(() => {
    setValue("landInfo.owners.[0].gender", "Male");
    setValue("landInfo.owners.[0].fatherOrHusbandName", "NA");
  }, [watchState]);

  const onSubmit = (data) => {
    handleSubTabChange(3, data);
  };
  console.log(engineersArr, "engineersArr");

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Licensed Technical Person (LTP)")}</h2>
          </div>
          <Container fluid className="formInputContainer">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Consultant Category")}`}
                  placeholder={`${t("Cosultant Category")}`}
                  name="professionaldetails.consultantCategory"
                  defaultValue={formData?.professionaldetails?.consultantCategory}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchCategoryType}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("LABEL_APPLICANT_NAME")}
                  control={control}
                  placeholder={t("LABEL_ENTER_NAME")}
                  name="professionaldetails.name"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.professionaldetails?.name}
                  type="textInput"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  disabled={formData?.professionaldetails?.name}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                {" "}
                <InputWrapper
                  label={t("LABEL_EMAIL_ID")}
                  control={control}
                  placeholder={t("LABEL_ENTER_APPLICANT_EMAIL_ID")}
                  name="professionaldetails.emailId"
                  defaultValue={formData?.professionaldetails?.emailId}
                  type="textInput"
                  mandatory
                  maxLength={25}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Email"),
                      message: "Please enter valid email id",
                    },
                  }}
                  disabled={formData?.professionaldetails?.emailId}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("Enter Mobile No")}
                  control={control}
                  placeholder={t("Mobile No")}
                  mobileNumber
                  mandatory
                  type="textInput"
                  name="professionaldetails.mobileNumber"
                  defaultValue={formData?.professionaldetails?.mobileNumber}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("MobileNo"),
                      message: "Please enter valid mobile no",
                    },
                  }}
                  maxLength={10}
                  disabled={formData?.professionaldetails?.mobileNumber}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                {" "}
                <InputWrapper
                  label="Certificate No. (For Minimum Qualification)"
                  control={control}
                  placeholder="Enter Certificate No"
                  maxLength={13}
                  type="textInput"
                  name="professionaldetails.certificateNo"
                  defaultValue={formData?.professionaldetails?.certificateNo}
                  disabled={!!watchCertNo || isEmployee}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("LABEL_VALID_UPTO")}
                  control={control}
                  placeholder="Select Date"
                  type="datePicker"
                  name="professionaldetails.validupto"
                  defaultValue={formData?.professionaldetails?.validupto}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchValidity}
                />
              </Col>
            </Row>
          </Container>
        </div>

        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Owner Information")}</h2>
          </div>
          <Container fluid className="formInputContainer">
            <Row>
              <Col>
                {" "}
                <InputWrapper
                  label={t("Name")}
                  control={control}
                  placeholder={t("LABEL_ENTER_NAME")}
                  name="landInfo.owners.[0].name"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.landInfo?.owners?.[0]?.name}
                  type="textInput"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  disabled={formData?.landInfo?.owners?.[0]?.name}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("Enter Mobile No")}
                  control={control}
                  placeholder={t("Mobile No")}
                  mobileNumber
                  mandatory
                  type="textInput"
                  name="landInfo.owners.[0].mobileNumber"
                  defaultValue={formData?.landInfo?.owners?.[0]?.mobileNumber}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("MobileNo"),
                      message: "Please enter valid mobile no",
                    },
                  }}
                  maxLength={10}
                  disabled={formData?.landInfo?.owners?.[0]?.mobileNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("LABEL_EMAIL_ID")}
                  control={control}
                  placeholder={t("LABEL_ENTER_APPLICANT_EMAIL_ID")}
                  name="landInfo.owners.[0].emailId"
                  defaultValue={formData?.landInfo?.owners?.[0]?.emailId}
                  type="textInput"
                  mandatory
                  maxLength={25}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Email"),
                      message: "Please enter valid email id",
                    },
                  }}
                  disabled={formData?.landInfo?.owners?.[0]?.emailId}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_STATE")}
                  placeholder={t("LABEL_ENTER_STATE")}
                  name="landInfo.owners.[0].permanentAddress.state"
                  defaultValue={formData?.landInfo?.owners?.[0]?.permanentAddress?.state}
                  type="selectInput"
                  data={statesName}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={formData?.landInfo?.owners?.[0]?.permanentAddress?.state}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={updistricts}
                  label={t("LABEL_CITY")}
                  placeholder={watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY")}
                  name="landInfo.owners.[0].correspondenceAddress.town"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.town}
                  type={watchState === "Uttar Pradesh" ? "selectInput" : "textInput"}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.town}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_PINCODE")}
                  placeholder={t("LABEL_ENTER_PINCODE")}
                  name="landInfo.owners.[0].correspondenceAddress.pinno"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Pincode"),
                      message: "Please enter valid Pincode",
                    },
                  }}
                  maxLength={6}
                  disabled={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  label={t("LABEL_ADDRESS")}
                  placeholder={t("LABEL_ENTER_ADDRESS")}
                  name="landInfo.owners.[0].correspondenceAddress.address"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Address"),
                      message: "Please enter valid Address",
                    },
                  }}
                  maxLength={50}
                  disabled={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address}
                />
              </Col>
              {/* <Col>
                <InputWrapper
                  label={t("Enter GST No")}
                  control={control}
                  placeholder={t("GST No")}
                  type="textInput"
                  name="landInfo.owners.[0].gstNumber"
                  defaultValue={formData?.landInfo?.owners?.[0]?.gstNumber}
                />
              </Col> */}
              <Col></Col>
            </Row>
            {/* <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={yesOrNo}
                  label={`${t("Do you want to take input on GST")}`}
                  placeholder={`${t("Cosultant Category")}`}
                  name="landInfo.owners.[0].inputonGST"
                  defaultValue={formData?.landInfo?.owners?.[0]?.inputonGST}
                  type="radioButton"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Site Address")}
                  placeholder={t("Enter Site Address")}
                  name="landInfo.owners.[0].permanentAddress.address"
                  defaultValue={formData?.landInfo?.owners?.[0]?.permanentAddress?.address}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Address"),
                      message: "Please enter valid Address",
                    },
                  }}
                  maxLength={50}
                  disablePast={formData?.landInfo?.owners?.[0]?.permanentAddress?.address}
                />
              </Col>
            </Row> */}
            {/* <Row>
              <Col>
                {" "}
                <FileUploader
                  isMandatory
                  label={t("LABEL_REGISTRATION_CERTIFICATE")}
                  control={control}
                  name="Registration Certificate"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                />
              </Col>
              <Col>
                {" "}
                <FileUploader
                  label={t("LABEL_PHOTO")}
                  control={control}
                  name="applicantPhoto"
                  validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                  required
                  isMandatory
                  tab={1}
                />
              </Col>
            </Row> */}
          </Container>
        </div>

        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Structural Engineer Information")}</h2>
          </div>
          <Container fluid className="formInputContainer">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Consultant Name")}`}
                  placeholder={`${t("Cosultant Name")}`}
                  name="structuralInfo.name"
                  defaultValue={formData?.structuralInfo?.name}
                  type="textInput"
                  disabled={isEmployee}
                  maxLength={50}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("License Number")}
                  placeholder={t("Enter License Number")}
                  name="structuralInfo.licenseNumber"
                  defaultValue={formData?.structuralInfo?.licenseNumber}
                  type="textInput"
                  disabled={isEmployee}
                  maxLength={50}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("LABEL_VALID_UPTO")}
                  control={control}
                  placeholder="Select Date"
                  type="datePicker"
                  name="structuralInfo.validupto"
                  defaultValue={formData?.structuralInfo?.validupto}
                  // validation={{
                  //     required: {
                  //         value: true,
                  //         message: "This field is required"
                  //     }
                  // }}
                  // disabled={isEmployee}
                  disabled={true}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_ADDRESS")}
                  placeholder={t("LABEL_ENTER_ADDRESS")}
                  name="structuralInfo.permanentAddress.address"
                  defaultValue={formData?.structuralInfo?.permanentAddress?.address}
                  type="textInput"
                  // mandatory
                  // validation={{
                  //     required: {
                  //         value: true,
                  //         message: "This field is required"
                  //     },
                  //     pattern: {
                  //         value: Digit.Utils.getPattern('Address'),
                  //         message: "Please enter valid Address",
                  //     },
                  // }}
                  // disabled={isEmployee}
                  disabled={true}
                  maxLength={50}
                />
              </Col>
            </Row>
          </Container>
        </div>

        {/* <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">
                            {t("Developer Information")}
                        </h2>
                    </div>
                    <Container fluid className="formInputContainer">
                        <Row>
                            <Col><InputWrapper
                                control={control}
                                label={`${t("Developer Name")}`}
                                placeholder={`${t("Developer Name")}`}
                                name="developerInfo.name"
                                defaultValue={formData?.developerInfo?.name}
                                type='textInput'
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            /></Col>
                            <Col><InputWrapper
                                label={t("License Number")}
                                control={control}
                                placeholder={t("Enter License Number")}
                                name="developerInfo.licenseNo"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.developerInfo?.licenseNo}
                                type="textInput"
                            /></Col>
                        </Row>
                        <Row>
                            <Col><InputWrapper
                                label={t("Enter Mobile No")}
                                control={control}
                                placeholder={t("Mobile No")}
                                mobileNumber
                                mandatory
                                type="textInput"
                                name="developerInfo.mobileNumber"
                                defaultValue={formData?.developerInfo?.mobileNumber}
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    },
                                    pattern: {
                                        value: Digit.Utils.getPattern('MobileNo'),
                                        message: "Please enter valid mobile no",
                                    },
                                }}
                                maxLength={10}
                            /></Col>
                            <Col>   <InputWrapper
                                control={control}
                                label={t("LABEL_ADDRESS")}
                                placeholder={t("LABEL_ENTER_ADDRESS")}
                                name="developerInfo.permanentAddress.address"
                                defaultValue={formData?.developerInfo?.permanentAddress?.address}
                                type="textInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    },
                                    pattern: {
                                        value: Digit.Utils.getPattern('Address'),
                                        message: "Please enter valid Address",
                                    },
                                }}
                                maxLength={50}
                            /></Col>
                        </Row>
                    </Container>
                </div> */}

        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleSubTabChange(1)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};
export default SubStep2;
